import type { BreakpointSize } from '../Breakpoint';

/**
 * Constants representing max-width constraints we currently use in our
 * components. These constraints are also available as CSS variables:
 * `var(--tfd-constraint-width-<size>)`.
 *
 * TODO: verify these values with Product Design.
 */
export enum WidthConstraint {
  /** Small width constraint (in px). */
  SM = 375,
  /** Medium width constraint (in px). */
  MD = 800,
  /** Large width constraint (in px). */
  LG = 1200,
  /** Extra large width constraint (in px). */
  XL = 1400,
}

/**
 * One of the available width constraints. See {@link WidthConstraint} for the
 * actual values.
 */
export type WidthConstraintSize = Lowercase<keyof typeof WidthConstraint>;

/** Represent a width constraint for each breakpoint. */
export type WidthConstraintResponsive = Partial<
  Record<BreakpointSize, WidthConstraintSize>
>;

export function isResponsiveWidthConstraint(
  value: WidthConstraintSize | WidthConstraintResponsive
): value is WidthConstraintResponsive {
  return typeof value === 'object';
}
